import React from 'react';
import { Check } from 'lucide-react';
import './Checkbox.css';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  error,
  helperText,
  className = '',
  id,
  checked,
  ...props
}) => {
  const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`checkbox-wrapper ${className}`}>
      <label htmlFor={checkboxId} className="checkbox-label">
        <div className="checkbox-input-wrapper">
          <input
            type="checkbox"
            id={checkboxId}
            className="checkbox-input"
            checked={checked}
            aria-invalid={!!error}
            aria-describedby={error ? `${checkboxId}-error` : helperText ? `${checkboxId}-helper` : undefined}
            {...props}
          />
          <div className={`checkbox-box ${checked ? 'checkbox-box--checked' : ''} ${error ? 'checkbox-box--error' : ''}`}>
            {checked && <Check size={14} strokeWidth={3} />}
          </div>
        </div>
        {label && <span className="checkbox-text">{label}</span>}
      </label>
      {error && (
        <span id={`${checkboxId}-error`} className="checkbox-error" role="alert">
          {error}
        </span>
      )}
      {helperText && !error && (
        <span id={`${checkboxId}-helper`} className="checkbox-helper">
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
